/*
  Calls to action for sections/ft-course-video.liquid, driven by Cloudflare
  Stream's player API (embed.cloudflarestream.com/embed/sdk.latest.js, loaded
  just before this file):
  - End card: shown when the video ends, after leaving fullscreen if the
    video was fullscreen in the page.
  - Pause panel: shown when the viewer pauses and stays paused for
    PAUSE_DELAY_MS, on the first pause and then no more often than the
    section's interval (data-pause-interval, in minutes; 0 means every pause).
    If the video is fullscreen in the page at that moment, the panel waits
    until fullscreen ends, so it isn't spent where nobody can see it.
  A panel's heading and line are also written to a polite live region, so
  screen readers announce it.
  - Timed lines: each shown while playback is inside its window (data-start
    for data-duration seconds). If windows overlap, the later start wins.
  Panels hide again when the video plays or moves along the timeline, on
  Escape, or on a tap on the panel's fill. Buttons and links marked
  data-ft-video-go pause the video (without bringing up the pause panel) and
  then go to their link; a link to an anchor that the course rail lists is
  passed to the rail's own link, so it scrolls the same way, clear of the
  pinned rail and header.

  Each instance of the section renders its own tag for this file, so the
  window.ftCourseVideo guard makes the setup run only once. parseTime is on
  it for testing from the console.

  Stream's player API only connects if it is attached before the iframe
  loads: the player posts one "ready" message, on load, and play, pause and
  seek commands wait for it. The section's inline script marks the iframe
  data-ft-load-tracked, and data-ft-loaded once it has loaded. If it has
  already loaded, or wasn't tracked (as after a theme editor re-render), the
  iframe is reloaded once here, after attaching, to get a fresh ready
  message.
*/
(function () {
  if (window.ftCourseVideo) return;
  var api = window.ftCourseVideo = {};

  // How long a pause must last before the pause panel fades in, so that
  // scrubbing along the timeline or a quick pause and resume doesn't make
  // it flash.
  var PAUSE_DELAY_MS = 1500;

  // "07:22", "7:22" or "1:02:05" (or plain seconds) to seconds; NaN if the
  // value isn't one of those.
  function parseTime(value) {
    var parts = String(value == null ? '' : value).trim().split(':');
    if (parts.length > 3) return NaN;
    var total = 0;
    for (var i = 0; i < parts.length; i++) {
      if (!/^\d+$/.test(parts[i])) return NaN;
      total = total * 60 + parseInt(parts[i], 10);
    }
    return total;
  }
  api.parseTime = parseTime;

  function exitFullscreenFor(iframe) {
    var current = document.fullscreenElement || document.webkitFullscreenElement;
    if (!current || !(current === iframe || current.contains(iframe))) return;
    var exit = document.exitFullscreen || document.webkitExitFullscreen;
    if (!exit) return;
    try {
      var result = exit.call(document);
      if (result && result.catch) result.catch(function () {});
    } catch (e) {}
  }

  function init(root) {
    if (!root || root.ftCourseVideo) return;
    var iframe = root.querySelector('.ft-course-video-frame iframe');
    if (!iframe || typeof window.Stream !== 'function') return;

    var player = window.Stream(iframe);
    if (!iframe.hasAttribute('data-ft-load-tracked') || iframe.hasAttribute('data-ft-loaded')) {
      iframe.src = iframe.src;
    }

    var endPanel = root.querySelector('[data-ft-video-panel="end"]');
    var pausePanel = root.querySelector('[data-ft-video-panel="pause"]');
    var announcer = root.querySelector('[data-ft-video-announcer]');
    var pauseIntervalMs = (parseFloat(root.getAttribute('data-pause-interval')) || 0) * 60000;
    var designMode = !!(window.Shopify && window.Shopify.designMode);

    // Every line, for the theme editor preview, and the ones with a usable
    // time window, for playback.
    var allLines = Array.prototype.slice.call(root.querySelectorAll('[data-ft-video-line]'))
      .map(function (el) {
        var start = parseTime(el.getAttribute('data-start'));
        return { el: el, start: start, end: start + (parseFloat(el.getAttribute('data-duration')) || 0) };
      });
    var lines = allLines.filter(function (line) { return isFinite(line.start) && line.end > line.start; });
    if (designMode) {
      // A start time that can't be read would otherwise just never show.
      allLines.forEach(function (line) {
        if (lines.indexOf(line) !== -1) return;
        var note = document.createElement('span');
        note.textContent = ' (Start time not recognised. Use minutes and seconds, such as 07:22.)';
        line.el.appendChild(note);
      });
    }

    var playedOnce = false;
    var pauseTimer = null;
    var lastPausePanelAt = null;
    // Set when the pause panel is due while the video is fullscreen in the
    // page, where nothing can show over it. It shows when fullscreen ends.
    // (iPhone's own fullscreen player can't be detected from the page; a
    // panel due then shows as soon as the viewer comes back, if still
    // paused.)
    var pausePanelPending = false;
    // Set when one of our own buttons or links pauses the video, so that
    // pause doesn't also bring up the pause panel.
    var ownPause = false;
    var editorLine = null;

    function isShown(panel) { return !!panel && panel.classList.contains('is-shown'); }

    function announce(panel) {
      if (!announcer) return;
      announcer.textContent = panel
        ? Array.prototype.map.call(panel.querySelectorAll('p'), function (p) { return p.textContent.trim(); }).join('. ')
        : '';
    }

    function hidePanel(panel) {
      if (!isShown(panel)) return;
      // Keep keyboard focus from falling back to the top of the page when
      // the control it was on disappears.
      if (panel.contains(document.activeElement)) iframe.focus();
      panel.classList.remove('is-shown');
      if (!isShown(endPanel) && !isShown(pausePanel)) announce(null);
    }

    function showPanel(panel) {
      if (!panel) return;
      [endPanel, pausePanel].forEach(function (other) { if (other && other !== panel) hidePanel(other); });
      panel.classList.add('is-shown');
      announce(panel);
    }

    function hidePanels() {
      hidePanel(endPanel);
      hidePanel(pausePanel);
    }

    function cancelPausePanel() {
      clearTimeout(pauseTimer);
      pauseTimer = null;
      pausePanelPending = false;
    }

    function fullscreenHoldsVideo() {
      var current = document.fullscreenElement || document.webkitFullscreenElement;
      return !!current && (current === iframe || current.contains(iframe));
    }

    function showPausePanelIfDue() {
      // A pause also fires just before 'ended', which shows the end card
      // instead.
      if (!player.paused || player.ended || isShown(endPanel)) return;
      if (fullscreenHoldsVideo()) {
        pausePanelPending = true;
        return;
      }
      pausePanelPending = false;
      var now = Date.now();
      if (lastPausePanelAt !== null && now - lastPausePanelAt < pauseIntervalMs) return;
      lastPausePanelAt = now;
      showPanel(pausePanel);
    }

    function updateLines() {
      if (!allLines.length) return;
      // A line holding keyboard focus stays until focus leaves it, so its
      // link doesn't vanish from under the viewer.
      var active = editorLine;
      if (!active) {
        allLines.forEach(function (line) { if (line.el.contains(document.activeElement)) active = line; });
      }
      if (!active && !player.ended) {
        var t = player.currentTime;
        lines.forEach(function (line) {
          if (t >= line.start && t < line.end && (!active || line.start >= active.start)) active = line;
        });
      }
      allLines.forEach(function (line) { line.el.classList.toggle('is-shown', line === active); });
    }

    // Size "Largest that fits on one line": the largest size at which the
    // longest line fits the width on one line, capped at the size of the
    // header menu items (or Text size if there's no menu), and floored at
    // Smallest fitted size, below which the lines wrap. Every line shares
    // the one size. Each line is measured on one line at a large reference
    // size; its width scales with the font size, so the fitted size is the
    // reference size times the space available over the widest line.
    var linesBox = root.querySelector('.ft-course-video-lines');
    var fittedWidth = null;
    function fitLines() {
      if (!linesBox || linesBox.getAttribute('data-size-mode') !== 'fit') return;
      var available = linesBox.clientWidth;
      if (!available || available === fittedWidth) return;
      fittedWidth = available;
      var rootPx = parseFloat(getComputedStyle(document.documentElement).fontSize) || 10;
      var menuItem = document.querySelector('.header__menu-item');
      var maxRem = menuItem
        ? parseFloat(getComputedStyle(menuItem).fontSize) / rootPx
        : parseFloat(linesBox.style.getPropertyValue('--ft-course-video-line-size'));
      var minRem = parseFloat(linesBox.getAttribute('data-min-size')) || 1.5;
      var REFERENCE_REM = 10;
      var widest = 0;
      allLines.forEach(function (line) {
        var style = line.el.style;
        style.fontSize = REFERENCE_REM + 'rem';
        style.whiteSpace = 'nowrap';
        style.width = 'max-content';
        widest = Math.max(widest, line.el.getBoundingClientRect().width);
        style.fontSize = '';
        style.whiteSpace = '';
        style.width = '';
      });
      if (!widest) return;
      // 2% short of a perfect fit, so rounding can't push a line over.
      var fittedRem = REFERENCE_REM * available / widest * 0.98;
      var size = Math.min(fittedRem, maxRem || fittedRem);
      var oneLine = size >= minRem;
      if (!oneLine) size = minRem;
      linesBox.style.setProperty('--ft-course-video-line-size', (Math.floor(size * 100) / 100) + 'rem');
      linesBox.classList.toggle('is-one-line', oneLine);
    }
    if (linesBox && linesBox.getAttribute('data-size-mode') === 'fit') {
      fitLines();
      // Again once the web fonts have loaded (they change the widths), and
      // whenever the width changes.
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () { fittedWidth = null; fitLines(); });
      }
      // The resize listener backs up the observer: a stale fit left on one
      // line would push the page wider than the screen.
      if (window.ResizeObserver) new ResizeObserver(fitLines).observe(linesBox);
      window.addEventListener('resize', fitLines);
    }

    player.addEventListener('play', function () {
      cancelPausePanel();
      hidePanels();
    });
    player.addEventListener('playing', function () { playedOnce = true; });
    // Moving along the timeline means the viewer wants to see the picture.
    player.addEventListener('seeking', function () {
      cancelPausePanel();
      hidePanels();
    });
    player.addEventListener('pause', function () {
      cancelPausePanel();
      if (ownPause) {
        ownPause = false;
        return;
      }
      if (!pausePanel || !playedOnce) return;
      pauseTimer = setTimeout(function () {
        pauseTimer = null;
        showPausePanelIfDue();
      }, PAUSE_DELAY_MS);
    });
    player.addEventListener('ended', function () {
      cancelPausePanel();
      updateLines();
      if (!endPanel) return;
      exitFullscreenFor(iframe);
      showPanel(endPanel);
    });
    player.addEventListener('timeupdate', updateLines);
    player.addEventListener('seeked', updateLines);

    ['fullscreenchange', 'webkitfullscreenchange'].forEach(function (name) {
      document.addEventListener(name, function () {
        if (pausePanelPending && !fullscreenHoldsVideo()) showPausePanelIfDue();
      });
    });

    root.addEventListener('click', function (event) {
      var action = event.target.closest('[data-ft-video-action]');
      if (action) {
        if (action.getAttribute('data-ft-video-action') === 'replay') player.currentTime = 0;
        var played = player.play();
        if (played && played.catch) played.catch(function () {});
        hidePanels();
        return;
      }

      // A tap on the panel's fill, outside its text and buttons, dismisses
      // it and leaves the video as it is. Most of the fill is the inner box
      // and the row of buttons, so taps on those count too.
      var panel = event.target.closest('[data-ft-video-panel]');
      if (panel && (event.target === panel ||
          event.target.classList.contains('ft-course-video-panel-inner') ||
          event.target.classList.contains('ft-course-video-panel-actions'))) {
        hidePanel(panel);
        return;
      }

      var go = event.target.closest('[data-ft-video-go]');
      if (!go) return;
      if (!player.paused) {
        ownPause = true;
        player.pause();
      }
      var samePage = go.hash && go.pathname === window.location.pathname && go.host === window.location.host;
      if (!samePage) return;
      var id = go.hash.slice(1);
      var railLink = Array.prototype.filter.call(
        document.querySelectorAll('.ad-rail-link[data-rail-target]'),
        function (link) { return link.getAttribute('data-rail-target') === id; }
      )[0];
      if (!railLink) return;
      event.preventDefault();
      // The rail scrolls, then moves keyboard focus to the section.
      railLink.click();
    });

    root.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var panel = event.target.closest && event.target.closest('[data-ft-video-panel]');
      if (panel) hidePanel(panel);
    });

    // Once focus leaves a timed line, it can follow the timeline again.
    root.addEventListener('focusout', function (event) {
      if (event.target.closest && event.target.closest('[data-ft-video-line]')) setTimeout(updateLines, 0);
    });

    root.ftCourseVideo = {
      player: player,
      // Theme editor: selecting a Timed line block shows it, whatever its
      // start time.
      previewLine: function (el) {
        editorLine = null;
        allLines.forEach(function (line) { if (line.el === el) editorLine = line; });
        updateLines();
      }
    };
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-ft-video]'), init);
  }
  api.init = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    Array.prototype.forEach.call(event.target.querySelectorAll('[data-ft-video]'), function (root) {
      if (root.ftCourseVideo) root.ftCourseVideo.player.destroy();
    });
  });
  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest && event.target.closest('[data-ft-video]');
    if (root && root.ftCourseVideo) root.ftCourseVideo.previewLine(event.target);
  });
  document.addEventListener('shopify:block:deselect', function (event) {
    var root = event.target.closest && event.target.closest('[data-ft-video]');
    if (root && root.ftCourseVideo) root.ftCourseVideo.previewLine(null);
  });
})();
